module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTK7o+67p+67p+q7o+67o+6zo+a7o+p7l9K3p+qzg8K7p+67p+q3o+a7o+63n+q7o+q7o+q3o+q7o+q/p+qzm+a3o+a3n+a7o+oDZ0ZEAAAAYdFJOUwB1j5u08EH4BhgMxtDjXGjcqCW/MitQgNbx+t8AAACjSURBVBjTXZDZEoMgDADDEcIN4tH8/5dWtFYxDwyz5NgAAEsgaWGITFGxHNBCkwXB5sl07HUhPhmKfpohMfVWTg1MJQuZz+wrVi4wz6MKaLSSXn6OlaV3YuHN8NRvdp7+1bTmA2pi/M33FdvGtRnOLtDPwFVc1kS4r2Tl7nHCSMVn4Y5O1zyvWLvzGe8/2hKpnbaa3K3kP0hBU22DqC9aCw/wBVXjBpLkMIWDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/formImg/tel.png
// module id = f+fr
// module chunks = 0